import { createSlice } from "@reduxjs/toolkit";
import { QUESTIONNARIEMAPPING } from "../../utils/constants";

const initialState = {
  questionnarie:[],
  apiCredentialsContact: {},
  open: null,
  questionnarieUpdateStatus: { inProgress: false, isSuccess: false, isError: false },
};
 
const sellerDataSlice = createSlice({
  name: "sellerData",
  initialState,
  reducers: {
    reset: (state) => {
      state.open = null
      // state.questionnarie = []
      // state.apiCredentialsContact = {}
    },
    startQuestionnarieUpdate: (state) => {
      state.questionnarieUpdateStatus = { inProgress: true, isSuccess: false, isError: false };
    },
    setQuestionnarieUpdateSuccess: (state) => {
      state.questionnarieUpdateStatus = { inProgress: false, isSuccess: true, isError: false };
    },
    setQuestionnarieUpdateFailure: (state) => {
      state.questionnarieUpdateStatus = { inProgress: false, isSuccess: false, isError: true };
    },
    resetQuestionnarieUpdateStatus: (state) => {
      state.questionnarieUpdateStatus = { inProgress: false, isSuccess: false, isError: false };
    },
    setApiCredentialsContact: (state, action) => {
      state.apiCredentialsContact = action.payload.data
      state.open = true
    },
    setQuestionnarie: (state, action) => {      
      const res= [];
      if(action.payload.data?.questions?.length) {
        action.payload.data.questions.forEach(item => {
        try {
          if (item.sub_question_en) {
              const newItemEnQ = item.sub_question_en.split('//').map(subItem => subItem.split('|'))
              const question_en = newItemEnQ.map(item => Object.fromEntries(item.map(subItem => subItem.split(':'))))
             let answers = item.sub_answer?.split('|').map(item => item.split(':')[1]) || []
              answers = answers.filter((el, ind) => ind%2)
      
      
              const newItemFrQ = item.sub_question_fr.split('//').map(subItem => subItem.split('|'))
              const question_fr = newItemFrQ.map(item => Object.fromEntries(item.map(subItem => subItem.split(':'))))
      
      
              const formattedData = question_en.map((el, ind) => ({
                  survey_question_id: el.survey_sub_question_id,
                  survey_question_description_en: el.survey_sub_question_desc,
                  survey_question_description_fr: question_fr[ind].survey_sub_question_desc,
                  user_answer: (answers?.[ind] === undefined || answers[ind] === null || answers[ind] === "") ? "-" : answers[ind]
              }))

              res.push(...formattedData)
              res.push({
                  survey_question_id: item.survey_question_id,
                  survey_question_description_en: item.survey_question_description_en,
                  survey_question_description_fr: item.survey_question_description_fr,
                  user_answer: (item.user_answer === null || item.user_answer === "") ? "-" : item.user_answer
              });
                  
              
          } 
          else if (item.options_en) {
            const optionsEn = item.options_en.split('//').map(item => Object.fromEntries(item.split('|').map(item => item.split(':'))))
    
            const optionsFr = item.options_fr.split('//').map(item => Object.fromEntries(item.split('|').map(item => item.split(':'))))
    
            const answersOpts = item.options?.split(',') ?? []
    
            const optionsData = optionsEn.map((item, ind) => ({
              survey_option_id: item.survey_option_id,
              survey_question_description_en: item.survey_options_description,
              survey_question_description_fr: optionsFr[ind].survey_options_description,
              user_answer: answersOpts.includes(item.survey_option_id)
            }))

            res.push({
              survey_question_id: item.survey_question_id,
              survey_question_description_en: item.survey_question_description_en,
              survey_question_description_fr: item.survey_question_description_fr,
              optionsData
            })
          }
          else {
              res.push({
                  survey_question_id: item.survey_question_id,
                  survey_question_description_en: item.survey_question_description_en,
                  survey_question_description_fr: item.survey_question_description_fr,
                  user_answer: (item.user_answer === null || item.user_answer === "")? "-":item.user_answer
              })
          }
        } catch (err) {
          console.log("Failed to parse questionnaire item", item, err);
        }
        })
      }
      // Only render the known/mapped question IDs; ignore any extra/unexpected
      // IDs the backend may send (e.g. test/placeholder questions not in
      // QUESTIONNARIEMAPPING).
      state.questionnarie = QUESTIONNARIEMAPPING.map((que) => {
        const found = res?.find((item) => item.survey_question_id === que);
        if (found) {
          return found;
        }

        return {
          survey_question_id: que,
          survey_question_description_en: "",
          survey_question_description_fr: "",
          user_answer: "-",
        };
      });
    },
    getQuestionnarie:() => {},
    postQuestionnarie: () => {},
    putQuestionnarie: () => {},
    getApiCredentialsContact: () => {},
    putApiCredentialsContact: () => {},
  }
});
 
export const { getApiCredentialsContact, putApiCredentialsContact, getQuestionnarie, postQuestionnarie, putQuestionnarie, reset, setQuestionnarie, setApiCredentialsContact, startQuestionnarieUpdate, setQuestionnarieUpdateSuccess, setQuestionnarieUpdateFailure, resetQuestionnarieUpdateStatus } = sellerDataSlice.actions;
export default sellerDataSlice.reducer;